export default __webpack_public_path__ + "static/media/SourceSansPro-Bold.0c995bef.woff2";